/**
 * @generated SignedSource<<79b4ed5d546d06d5c6a02f90f65587fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateMailingListDescriptionInput = {
  description: string;
  id: string;
};
export type MailingListDetailsViewUpdateDescriptionMutation$variables = {
  input: UpdateMailingListDescriptionInput;
};
export type MailingListDetailsViewUpdateDescriptionMutation$data = {
  readonly updateMailingListDescription: {
    readonly description: string;
    readonly id: string;
  };
};
export type MailingListDetailsViewUpdateDescriptionMutation = {
  response: MailingListDetailsViewUpdateDescriptionMutation$data;
  variables: MailingListDetailsViewUpdateDescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "updateMailingListDescription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListDetailsViewUpdateDescriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MailingListDetailsViewUpdateDescriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a1c557a9497b97686c372ebfba2305d",
    "id": null,
    "metadata": {},
    "name": "MailingListDetailsViewUpdateDescriptionMutation",
    "operationKind": "mutation",
    "text": "mutation MailingListDetailsViewUpdateDescriptionMutation(\n  $input: UpdateMailingListDescriptionInput!\n) {\n  updateMailingListDescription(input: $input) {\n    id\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "33253d07d3eaadb21b769e5ea258696a";

export default node;
